import { defineStore, createPinia } from 'pinia';
import piniaPersistConfig from '@/config/piniaPersist';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { menuData } from '../menuData';
import { learningType } from '@/helpers/qbankParser/qbankMeta';

// AuthStore
export const StudyStore = defineStore({
    id: 'StudyState',
    state: () => ({
        // navigation Data
        level: 0,
        lesson: 0,
        exprVersion: '',
        learningType: '',
        mapTree: {
            exams: [
                // {
                //     examCode: 'KRT_03_01_L_01',
                //     version: '1.00.01',
                //     headerEtcCd02: '05',
                //     headerEtcCd01: '72',
                //     title: '귀뚜라미에게 받은 짧은 편지',
                //     areaCode: 'L',
                //     isDone: false,
                //     learningType: '',
                //     learningStatus: '',
                //     difficult: {
                //         5077: '03',
                //         5078: '03',
                //         5079: '04',
                //         5085: '04',
                //         5080: '05',
                //         5081: '05',
                //     },
                // },
                // {
                //     examCode: 'KRT_03_01_L_02',
                //     version: '1.00.01',
                //     headerEtcCd02: '05',
                //     headerEtcCd01: '72',
                //     title: '낙화',
                //     areaCode: 'L',
                //     isDone: false,
                //     learningType: '',
                //     learningStatus: '',
                //     difficult: {
                //         5077: '03',
                //         5078: '03',
                //         5079: '04',
                //         5085: '04',
                //         5080: '05',
                //         5081: '05',
                //     },
                // },
                // {
                //     examCode: 'KRT_03_01_N_01',
                //     version: '1.00.01',
                //     headerEtcCd02: '02',
                //     headerEtcCd01: '',
                //     title: '상물림과 우리 고유의 가치관',
                //     areaCode: 'N',
                //     isDone: false,
                //     learningType: '',
                //     learningStatus: '',
                //     difficult: {
                //         5077: '03',
                //         5078: '03',
                //         5079: '04',
                //         5085: '04',
                //         5080: '05',
                //         5081: '05',
                //     },
                // },
                // {
                //     examCode: 'KRT_03_01_N_02',
                //     version: '1.00.01',
                //     headerEtcCd02: '02',
                //     headerEtcCd01: '',
                //     title: '순자가 바라본 하늘',
                //     areaCode: 'N',
                //     isDone: false,
                //     learningType: '',
                //     learningStatus: '',
                //     difficult: {
                //         5077: '03',
                //         5078: '03',
                //         5079: '04',
                //         5085: '04',
                //         5080: '05',
                //         5081: '05',
                //     },
                // },
            ],
        },
        // 현재 학습 단계 정보
        process: {
            // examCode: 'KRT_03_01_N_01',
            // examCode: 'KRT_02_01_N_02',
            // version: '1.00.01',
            // headerEtcCd02: '05',
            // headerEtcCd01: '72',
            // LN: 'L',
            // passage: 1,
            exam: {
                // examCode: 'KRT_01_01_L_01',
                // version: '1.00.01',
                // headerEtcCd02: '02',
                // headerEtcCd01: '',
                // title: '상물림과 우리 고유의 가치관',
                // areaCode: 'L',
                // isDone: false,
                // learningType: '',
                // learningStatus: '',
                // difficult: {
                //     5077: '03',
                //     5078: '03',
                //     5079: '04',
                //     5085: '04',
                //     5080: '05',
                //     5081: '05',
                // },
            },
            // mapTree index
            // examIdx: 0,
            // // 코너정보
            // studyTree: 5082,
            // // 문제 번호
            // problemOrd: 11,
            // // learningHistorySeq: 0,
            // learningHistorySeq: 47,
        },
        // 최종 학습 단계 정보
        lastProcess: {
            examIdx: 0,
            studyTree: 0,
            problemOrd: 0,
            // headerEtcCd02: '05',
            // headerEtcCd01: '72',
            // LN: 'L',
            // passage: 1,
            // studyTree: 5084,
            // problemOrd: 11,
        },
        // 학습 중간데이터
        currentInfo: {
            answer: [],
        },
        difficultyL: {},
        difficultyN: {},
        report: {
            level: 1,
            lesson: 1,
            areaCode: '02',
            learningTypeCode: 1,
        },
        suggestionIdx: '',
        videoPlayTime: '', //2023-11-13 pby 동영상 타임제어용 추가.
        videoStatus: '', //2023-11-24 pby 동영상 상태 여부용 추가.
    }),
    getters: {
        // getter
    },
    actions: {
        setExamLearningType() {
            this.process.exam.learningType = this.process.exam.orgLearningType;
        },
        async setProcess(params) {
            this.process = params;
        },
        async setMap(params) {
            this.map = params;
        },
        async setLearningType(params) {
            this.learningType = params;
        },
        async setNextProcess() {
            this.process = {
                exam: this.mapTree.exams[this.process.examIdx + 1],
                examIdx: this.process.examIdx + 1,
                studyTree: 5082,
                problemOrd: 0,
            };
            if (this.process.examIdx + 1 > this.lastProcess.examIdx) {
                this.lastProcess = {
                    exam: this.mapTree.exams[this.process.examIdx + 1],
                    examIdx: this.process.examIdx + 1,
                    studyTree: 5082,
                    problemOrd: 0,
                };
            }
        },
        async setNextStep(studyTree = false, problemOrd = false) {
            if (studyTree !== false) {
                this.process.studyTree = studyTree;
            }
            if (problemOrd !== false) {
                this.process.problemOrd = problemOrd;
            }

            if (this.process.examIdx === this.lastProcess.examIdx) {
                if (studyTree !== false) {
                    this.lastProcess.studyTree = studyTree;
                }
                if (problemOrd !== false) {
                    this.lastProcess.problemOrd = problemOrd;
                }
            }
        },
        async setMoveNav(idx, studyTree) {
            this.currentInfo = {
                exam: this.mapTree.exams[idx],
                examIdx: idx,
                studyTree: studyTree,
            };
        },
        async initStore(params) {
            this.level = 0;
            this.lesson = 0;
            this.exprVersion = '';
            this.mapTree = {
                exams: [],
            };
            this.process = {
                exams: [],
            };
            this.lastProcess = {
                examIdx: 0,
                studyTree: 0,
                problemOrd: 0,
            };
            (this.currentInfo = {
                answer: [],
            }),
                (this.difficultyL = {});
            this.difficultyN = {};
            this.report = {
                level: 1,
                lesson: 1,
                areaCode: '02',
                learningTypeCode: 1,
            };
        },

        async setSuggestionIdx(str) {
            this.suggestionIdx = str;
            console.log('setSuggestionIdx ===', this.suggestionIdx);
        },
        async setVideoPlayTime(videoPlayTime) {
            //2023-11-13 pby 동영상 타임제어용 추가.
            this.videoPlayTime = videoPlayTime;
        },
        async setVideoStatus(videoStatus) {
            //2023-11-24 pby 동영상 상태 여부용 추가.
            this.videoStatus = videoStatus;
        },
    },
    persist: piniaPersistConfig('StudyState'),
});

// piniaPersist
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;
